<template>
  <div class="listview">
    <table>
      <thead class="none">
        <tr>
          <td class="listview__title" v-for="(header, index) in headers" :key="index">{{header | capitalize}}</td>
          <td></td>
          <td></td>
        </tr>
      </thead>
      <tbody>
          <tr v-for="(item, index) in itemList" :key="index" @click.stop="listClick(item)" class="content">
            <td class="item">
              <img v-if="item.thumbnail_square" :src="item.thumbnail_square" alt="">
              <img v-else :src="`/img/notfound/img-placeholder_square.jpg`" alt="">
              <div class="stack">
                <span class="title">{{item.location_name}}</span>
                <span class="location" v-if="item.category === 'AR' && item.airport">
                  {{item.airport.airport_name}} . {{item.city_name}}
                </span>
                <span class="location" v-else>
                  {{item.property_type_display}} . {{item.city_name}}
                </span>
                <span class="price-mobile">{{item.price | formatMoney}}</span>
              </div>
            </td>
            <td class="placement none"><span>{{item.placement}}</span></td>
            <td v-if="item.is_audience_displayed" class="visitor none"><span>{{item.audience_daily}} people</span></td>
            <td v-else class="visitor none">-</td>
            <td class="price none"><span> {{item.price | formatMoney}} </span></td>
            <td class="icon-list" @click.stop="removeItem(item)"
            @mouseover="isHover = item.id" @mouseout="isHover = null">
              <adx-loading-secondary v-if="isLoading.includes(item.id)" />
              <i v-if="!isLoading.includes(item.id)" class="adx-ic_check" :class="{'adx-ic_close' : isHover == item.id}"></i>
            </td>
            <td class="menu-action"><menu-expansion :itemID="item.id" @selected="selected" :lists="menuList" /></td>
          </tr>
          <tr v-if="isShowMore" @click="isShowMore = false; allShown = true;">
            <td colspan="6" class="show-more"> <span> Show More </span> </td>
          </tr>
      </tbody>
      <slot name="infiniteLoading"/>
    </table>
    <div class="listview__loadingWrapper">
      <slot name="loading" />
    </div>
  </div>
</template>

<script>
import MenuExpansion from '@/components/MenuExpansion'
import LoadingSecondary from '@/components/Loading/Secondary'

import api from '@/api/'
import { apiV2 } from '@/api/urls'
import { mapGetters, mapActions, mapMutations } from 'vuex'

export default {
  name: 'adx-list-view',
  components: {
    'menu-expansion': MenuExpansion,
    'adx-loading-secondary': LoadingSecondary
  },
  props: {
    items: {
      required: false
    },
    category: {
      required: false
    },
    menuList: {
      required: false
    },
  },
  data() {
    return {
      isHover: null,
      isShowMore: false,
      allShown: false,
      headers: [
      'items',
      'placement',
      'daily visitor',
      'price / day'
      ],
      isLoading: []
    }
  },
  computed: {
    itemList() {
      if (this.items.length > 10 && !this.allShown) {
        this.isShowMore = true
        return this.items.slice(0, 10)
      }
      return this.items
    }
  },
  methods: {
    removeItem(item) {
      if(this.$route.params.id == this.$store.getters.defaultSaved) {
        let data = {
            'channel_id': item.id,
            'channel_type': this.category
        };

        (async () => {
          this.isLoading.push(item.id)
          const { response, msg } = await this.$store.dispatch('addRemoveSaved', {item: item, category: data.channel_type})
          this.$notify({
            group: 'saved',
            title: msg.title,
            text: msg.text,
            type: msg.type
          });
          this.$emit('reloadData')
          this.isLoading = []
        })();
      } else {
        let category = this.category

        const devices = ['lifestyle', 'malls', 'spbu', 'airport']
        if (devices.includes(category)) {
          category = 'device'
        }

        let data = {
            'channel_id': item.id,
            'channel_type': category
        };
        (async () => {
          this.isLoading.push(item.id)

          const response = await api.patch(apiV2.savedDetail(this.$route.params.id), data, { needToken: true })
          if (response.status == 200) {
            this.$notify({
              group: 'saved',
              title: 'Removed from saved',
              text: 'listing item has been removed from saved folder',
              type: 'primary'
            });
          } else {
            this.$notify({
              group: 'saved',
              title: 'Error',
              text: 'sorry something went wrong!',
              type: 'warn'
            });
          }
          this.$emit('reloadData')
          this.isLoading = []
        })();
      }
    },
    selected(menuObject) {
      if (menuObject.value == 'saved') {
        let category = this.category

        const devices = ['lifestyle', 'malls', 'spbu', 'airport']
        if (devices.includes(category)) {
          category = 'device'
        }

        if (menuObject.items.value !== 0) {
          let data = {
              'target_id': menuObject.items.value,
              [category]: menuObject.item_id
          };
          (async () => {
            const response = await api.patch(apiV2.savedCopy, data, { needToken: true })
            if (response.status == 200) {
              this.$notify({
                group: 'saved',
                title: 'Added to another saved',
                text: 'listing item has been added to saved folder',
                type: 'success'
              });
            }else {
              this.$notify({
                group: 'saved',
                title: 'Error',
                text: 'sorry something went wrong!',
                type: 'warn'
              });
            }
          })();
        } else {
          const params = {
            [category+'s']: [menuObject.item_id]
          }
          this.$emit('createNew', params)
        }
      }else if (menuObject.value == 'campaign'){
        let category = this.category
        const devices = ['lifestyle', 'malls', 'spbu', 'airport']
        if (devices.includes(category)) {
          category = 'idooh'
        }
        if (menuObject.items.value !== 0) {
          let data = {
              'channel_id': menuObject.item_id,
              'channel_name': category
          };
          (async () => {
            const response = await api.patch(apiV2.campaignAddListing(menuObject.items.value), data, { needToken: true })
            if (response.status == 200) {
              let item = this.items.filter(value => {
                return value.id == menuObject.item_id
              })[0]
              let campaign = this.menuList[1].items.filter(obj => {
                return obj.value == menuObject.items.value
              })[0]
              this.$notify({
                group: 'saved',
                title: 'Added to campaign',
                text: item.location_name + ' has been added to ' + campaign.name,
                type: 'success'
              });
            }else {
              this.$notify({
                group: 'saved',
                title: 'Error',
                text: 'sorry something went wrong!',
                type: 'warn'
              });
            }
          })();
        } else {
          let item = this.items.filter(value => {
            return value.id == menuObject.item_id
          })[0]
          const params = {
            category: category,
            device_id: menuObject.item_id,
            location_name: item.location_name
          }
          this.$emit('createNewCampaign', params)
        }
      } else if (menuObject.value == 'detail') {
        let item = this.itemList.filter(value => {
          return value.id == menuObject.item_id
        })[0]
        this.listClick(item)
      }
    },
    listClick(item) {
      this.$emit('item-clicked', { item: item })
    },
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>